import grecia from "../../assets/images/cards/grecia.png";
import disney from "../../assets/images/cards/disney/disney.png";
import d1 from "../../assets/images/cards/disney/d1.png";
import d2 from "../../assets/images/cards/disney/d2.png";
import d3 from "../../assets/images/cards/disney/d3.png";
import d4 from "../../assets/images/cards/disney/d4.png";
import d5 from "../../assets/images/cards/disney/d5.png";
import b1 from "../../assets/images/cards/bariloche/b1.png";
import b2 from "../../assets/images/cards/bariloche/b2.png";
import b3 from "../../assets/images/cards/bariloche/b3.png";
import b4 from "../../assets/images/cards/bariloche/b4.png";
import b5 from "../../assets/images/cards/bariloche/b5.png";
import cp1 from "../../assets/images/cards/capadocia/cp1.png";
import cp2 from "../../assets/images/cards/capadocia/cp2.png";
import cp3 from "../../assets/images/cards/capadocia/cp3.png";
import cp4 from "../../assets/images/cards/capadocia/cp4.png";
import cp5 from "../../assets/images/cards/capadocia/cp5.png";
import r1 from "../../assets/images/cards/roma/r1.png";
import r2 from "../../assets/images/cards/roma/r2.png";
import r3 from "../../assets/images/cards/roma/r3.png";
import r4 from "../../assets/images/cards/roma/r4.png";
import r5 from "../../assets/images/cards/roma/r5.png";
import mp1 from "../../assets/images/cards/machupicchu/mp1.png";
import mp2 from "../../assets/images/cards/machupicchu/mp2.png";
import mp3 from "../../assets/images/cards/machupicchu/mp3.png";
import mp4 from "../../assets/images/cards/machupicchu/mp4.png";
import mp5 from "../../assets/images/cards/machupicchu/mp5.png";
import br1 from "../../assets/images/cards/barcelona/br1.png";
import br2 from "../../assets/images/cards/barcelona/br2.png";
import br3 from "../../assets/images/cards/barcelona/br3.png";
import br4 from "../../assets/images/cards/barcelona/br4.png";
import br5 from "../../assets/images/cards/barcelona/br5.png";
import g1 from "../../assets/images/cards/grecia/g1.png";
import g2 from "../../assets/images/cards/grecia/g2.png";
import g3 from "../../assets/images/cards/grecia/g3.png";
import g4 from "../../assets/images/cards/grecia/g4.png";
import g5 from "../../assets/images/cards/grecia/g5.png";
import nyc1 from "../../assets/images/cards/nyc/nyc1.png";
import nyc2 from "../../assets/images/cards/nyc/nyc2.png";
import nyc3 from "../../assets/images/cards/nyc/nyc3.png";
import nyc4 from "../../assets/images/cards/nyc/nyc4.png";
import nyc5 from "../../assets/images/cards/nyc/nyc5.png";
import s1 from "../../assets/images/s1.png";
import s2 from "../../assets/images/s2.png";
import s3 from "../../assets/images/s3.png";
import s4 from "../../assets/images/s4.png";
import s5 from "../../assets/images/s5.png";
import newyork from "../../assets/images/cards/nyc/newyork.png";
import machupicchu from "../../assets/images/cards/machupicchu/machupicchu.png";
import barcelona from "../../assets/images/cards/barcelona/barcelona.png";
import roma1 from "../../assets/images/cards/roma/roma1.png";
import bariloche from "../../assets/images/cards/bariloche/bariloche.png";
import capadocia from "../../assets/images/cards/capadocia/capadocia.png";
import swiss from "../../assets/images/swiss.png";

const destinations = [
  {
    image: disney,
    title: "Walt Disney World Resort",
    location: "Orlando, EUA",
    description:
      "O Walt Disney World Resort é um dos destinos turísticos mais icônicos do mundo, localizado em Orlando, Flórida...",
    images: [d1, d2, d3, d4, d5],
  },
  {
    image: bariloche,
    title: "Bariloche",
    location: "Argentina",
    description:
      "Bariloche, localizada na região dos Lagos Andinos, é um destino de montanha que encanta visitantes com sua beleza natural.",
    images: [b1, b2, b3, b4, b5],
  },
  {
    image: capadocia,
    title: "Capadócia",
    location: "Turquia",
    description:
      "A Capadócia é uma região mágica na Turquia, famosa por suas formações rochosas únicas e balões de ar quente.",
    images: [cp1, cp2, cp3, cp4, cp5],
  },
  {
    image: roma1,
    title: "Roma",
    location: "Italia",
    description:
      "Roma, a capital da Itália, é um destino repleto de história, arte e cultura...",
    images: [r1, r2, r3, r4, r5], // Adicione imagens extras se tiver
  },
  {
    image: machupicchu,
    title: "Machu Picchu",
    location: "Peru",
    description:
      "Machu Picchu é uma das maravilhas do mundo moderno, localizada nas montanhas dos Andes peruanos...",
    images: [mp1, mp2, mp3, mp4, mp5], // Adicione imagens extras se necessário
  },
  {
    image: barcelona,
    title: "Barcelona",
    location: "Espanha",
    description:
      "Barcelona é uma cidade vibrante e cheia de vida, famosa por sua arquitetura única e cultura rica.",
    images: [br1, br2, br3, br4, br5],
  },
  {
    image: grecia,
    title: "Santorini",
    location: "Santorini, Grécia",
    description:
      "Com suas casas brancas e cúpulas azuis que contrastam com o mar cristalino, Santorini é um dos destinos mais românticos do mundo...",
    images: [g1, g2, g3, g4, g5],
  },
  {
    image: newyork,
    title: "Nova Iorque",
    location: "EUA",
    description:
      "Nova Iorque, a cidade que nunca dorme, é um destino icônico repleto de cultura, arte e entretenimento.",
    images: [nyc1, nyc2, nyc3, nyc4, nyc5],
  },
  {
    image: swiss,
    title: "Suíça",
    location: "Europa",
    description:
      "A Suíça é um país conhecido por suas paisagens deslumbrantes, montanhas majestosas e cidades encantadoras.",
    images: [s1, s2, s3, s4, s5],
  },
];

export default destinations;
